module.exports = __webpack_public_path__ + "static/media/Image7.5b498db3.png";